"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var backdropTransparency = {
  light: 0.95,
  normal: 0.8
};

var backdrop = function backdrop(transparency) {
  return function (theme) {
    return /*#__PURE__*/(0, _react.css)("background-color:rgba(\n    ", theme.color.monochrome.black_rgba, ",\n    ", backdropTransparency[transparency], "\n  );position:fixed;inset:0;z-index:1050;" + (process.env.NODE_ENV === "production" ? "" : ";label:backdrop;"));
  };
};

var dialog = process.env.NODE_ENV === "production" ? {
  name: "12x5t2v",
  styles: "position:fixed;inset:0;z-index:1055;overflow-y:auto"
} : {
  name: "15hxdn6-dialog",
  styles: "position:fixed;inset:0;z-index:1055;overflow-y:auto;label:dialog;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var panelCenter = /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;&&>*{margin-top:", (0, _util.rem)(36), ";margin-bottom:", (0, _util.rem)(36), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:panelCenter;"));

var panel = function panel(theme) {
  return /*#__PURE__*/(0, _react.css)("border-radius:", (0, _util.rem)(12), ";box-shadow:0 ", (0, _util.rem)(2), " ", (0, _util.rem)(24), " 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);background-color:", theme.color.monochrome.white, ";padding:", (0, _util.rem)(24), " ", (0, _util.rem)(30), " ", (0, _util.rem)(20), ";max-width:", (0, _util.rem)(640), ";margin-top:", (0, _util.rem)(142), ";color:", theme.color.info['900'], ";@media only screen and (max-width: ", theme.breakpoints.mediumMonitorBreakpoint, "){margin-top:", (0, _util.rem)(60), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:panel;"));
};

var loadingPanel = /*#__PURE__*/(0, _react.css)("justify-content:center;min-height:", (0, _util.rem)(500), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:loadingPanel;"));
var color = process.env.NODE_ENV === "production" ? {
  name: "opde7s",
  styles: "color:inherit"
} : {
  name: "1qofpni-color",
  styles: "color:inherit;label:color;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var description = /*#__PURE__*/(0, _react.css)("max-width:", (0, _util.rem)(415), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:description;"));

var button = function button(theme) {
  return /*#__PURE__*/(0, _react.css)("font-family:", theme.font.secondary, ";font-weight:", theme.fontWeight.normal, ";border-radius:", (0, _util.rem)(200), ";width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:button;"));
};

var link = function link(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.medium, ";color:", theme.color.monochrome.mediumDark, ";font-size:", theme.fontSize.large, ";text-decoration:underline;transition:color 0.2s;&:hover{color:", theme.color.monochrome.dark, ";}&:active{color:", theme.color.monochrome.mediumDark, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:link;"));
};

var instructions = function instructions(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.superLight, ";border-radius:", (0, _util.rem)(2), ";h5{font-size:inherit;font-weight:", theme.fontWeight.medium, ";}img{width:", (0, _util.rem)(40), ";flex-shrink:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:instructions;"));
};

var closeBtn = function closeBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;left:100%;bottom:calc(100% - ", (0, _util.rem)(10), ");svg{color:", theme.color.monochrome.white, ";opacity:0.5;width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";transition:opacity,0.2s;}&:hover{svg{opacity:0.8;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:closeBtn;"));
};

var AttachedContainer = function AttachedContainer(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.info['900'], ";padding:", (0, _util.rem)(25), " ", (0, _util.rem)(32), " ", (0, _util.rem)(55), ";border-top-right-radius:", (0, _util.rem)(12), ";border-bottom-right-radius:", (0, _util.rem)(12), ";width:", (0, _util.rem)(236), ";position:absolute;top:50%;left:100%;transform:translateY(-50%);" + (process.env.NODE_ENV === "production" ? "" : ";label:AttachedContainer;"));
};

var attachedContainerHeading = function attachedContainerHeading(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", (0, _util.rem)(17), ";color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:attachedContainerHeading;"));
};

var copyField = function copyField(theme) {
  return /*#__PURE__*/(0, _react.css)("&&{max-width:unset;border-radius:", (0, _util.rem)(4), ";&>*:hover{border-color:", theme.color.primary.info, ";}input{background-color:", theme.color.monochrome.white, ";border-top-right-radius:unset;border-bottom-right-radius:unset;color:", theme.color.info['900'], ";font-size:", theme.fontSize.xlarge, ";}button{min-width:", (0, _util.rem)(74), ";background-color:", theme.color.monochrome.light, ";color:", theme.color.info['900'], ";font-weight:", theme.fontWeight.medium, ";font-size:", theme.fontSize.xlarge, ";border-top-right-radius:", (0, _util.rem)(4), ";border-bottom-right-radius:", (0, _util.rem)(4), ";border:unset;height:", (0, _util.rem)(38), ";margin-right:", (0, _util.rem)(2), ";padding:", (0, _util.rem)(10), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:copyField;"));
};

var loadingText = process.env.NODE_ENV === "production" ? {
  name: "p9rzxl",
  styles: "opacity:0;visibility:hidden;transition:opacity 0.2s ease-in-out"
} : {
  name: "15lkipd-loadingText",
  styles: "opacity:0;visibility:hidden;transition:opacity 0.2s ease-in-out;label:loadingText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var showText = process.env.NODE_ENV === "production" ? {
  name: "nk3zlf",
  styles: "opacity:1;visibility:visible"
} : {
  name: "125du4h-showText",
  styles: "opacity:1;visibility:visible;label:showText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  backdrop: backdrop,
  dialog: dialog,
  panelCenter: panelCenter,
  panel: panel,
  loadingPanel: loadingPanel,
  color: color,
  description: description,
  button: button,
  link: link,
  instructions: instructions,
  closeBtn: closeBtn,
  AttachedContainer: AttachedContainer,
  attachedContainerHeading: attachedContainerHeading,
  copyField: copyField,
  loadingText: loadingText,
  showText: showText
};
exports.styles = styles;
//# sourceMappingURL=Modal.styles.js.map